import {Salutation, UserDisplayDTO} from "@/api/data-contracts";
import { CommonI18N } from "@/translations";

export function getFullName(user?: UserDisplayDTO): string {
    return user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}`.trim() : "";
}

function getSalutation(t: (key: string) => string, salutation?: Salutation) {
    switch (salutation) {
        case Salutation.DIVERS:
            return t(CommonI18N.enum.salutation.DIVERS);
        case Salutation.MR:
            return t(CommonI18N.enum.salutation.MR);
        case Salutation.MS:
            return t(CommonI18N.enum.salutation.MS);
        case Salutation.DR_FEMALE:
            return t(CommonI18N.enum.salutation.DR_FEMALE);
        case Salutation.DR_MALE:
            return t(CommonI18N.enum.salutation.DR_MALE);
        case Salutation.PROF_FEMALE:
            return t(CommonI18N.enum.salutation.PROF_FEMALE);
        case Salutation.PROF_MALE:
            return t(CommonI18N.enum.salutation.PROF_MALE);
        default:
            return "";
    }
}

export function formatUserName(t: (key: string) => string, user?: UserDisplayDTO): string {
    return user == null ? "" : `${getSalutation(t, user.salutation)} ${user.firstName} ${user.lastName}`.trim();
}
